<template>
  <div>
    <v-card v-if="!displayUrl" color="#f1f1f1" outlined style="height: 230px">
      <v-card-text class="pt-5">
        <div class="text-center">
          <v-icon size="80" color="grey">mdi-camera-outline</v-icon>
        </div>
      </v-card-text>
      <v-card-actions class="pb-3">
        <v-btn
          @click="handleClickTakePhoto"
          class="mx-auto"
          :color="insurer.color"
          dark
          elevation="0"
        >
          Anexar fotografia
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else flat color="black" style="height: 230px">
      <v-img :src="displayUrl" contain style="height: 230px" />
      <v-btn
        @click="handleClickTakePhoto"
        icon
        dark
        absolute
        style="bottom: 10px; right: 10px"
      >
        <v-icon>mdi-rotate-left</v-icon>
      </v-btn>
    </v-card>
    <input
      ref="fileInput"
      type="file"
      accept="image/*"
      hidden
      @change="handleImageLoaded"
    />
  </div>
</template>

<script>
export default {
  props: {
    insurer: Object,

    modelValue: {
      type: [File, null],
      default: null,
    },

    src: {
      type: String,
      default: null,
    },
  },

  model: {
    prop: "modelValue",
    event: "update",
  },

  data() {
    return {
      localUrl: null,
    };
  },

  computed: {
    displayUrl() {
      if (this.modelValue instanceof File) {
        return this.localUrl;
      }

      return this.src;
    },
  },

  watch: {
    modelValue(file) {
      if (!file) {
        this.localUrl = null;
        return;
      }

      this.localUrl = URL.createObjectURL(file);
    },
  },

  methods: {
    handleClickTakePhoto() {
      this.$refs.fileInput.value = null;
      this.$refs.fileInput.click();
    },

    handleImageLoaded(event) {
      const file = event.target.files?.[0];
      if (!file) return;

      this.$emit("update", file);
    },
  },
};
</script>
